module.exports = __webpack_public_path__ + "img/2.73a72898.png";